import React from 'react';
import { useTheme } from 'styled-components';

import { SVGPropsType } from 'src/types';

function BuySellSingle(props: SVGPropsType) {
    const { onClick, style, className, direction, active } = props;
    const { colors } = useTheme();

    let color = colors.exchange.buy;
    if (direction === 'sell') {
        color = colors.exchange.sell;
    }

    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            {active ? (
                <rect width="24" height="24" rx="4" fill={colors.background.secondary.v3} />
            ) : null}

            <path
                d="M10.6667 6H6V18H10.6667V6Z"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.9987 6H13.332"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.9987 10.8008H13.332"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.9987 8.40039H13.332"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.9987 13.1992H13.332"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.9987 18H13.332"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M17.9987 15.5996H13.332"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default BuySellSingle;
